import { InputText } from 'primereact/inputtext';

const AIEduInputText = (props) => {
    const { title, titleStyle, suffix, width } = props;

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                width,
            }}
        >
            <label htmlFor={title} className={titleStyle}>
                {title} {suffix}
            </label>
            <InputText {...props} />
        </div>
    );
};

export default AIEduInputText;
